import { NgModule } from '@angular/core';

import { CrownConnectDataService } from './cc-data.service';

@NgModule({
	providers: [
		CrownConnectDataService
	]
})
export class CrownConnectDataModule { }